import { Dispatch } from 'redux';
import http from '../utils/http';
import axios from 'axios';
import * as Cookies from 'js-cookie';
import { getAllMedia, addNewMedia } from '../actions/media.actions';
import { IApplicationState } from '../reducers';
import config from '../config';
import { getFilenameWithoutExtension } from '../utils/string';
import actionType from '../actions/actionTypes';
/**
 * Get all medias
 */
export function getAllMedias() {
    return async (
        dispatch: Dispatch<any>,
        getState: () => IApplicationState
    ) => {
        // @todo: Get Tenant ID from store rather than localstorage
        const tenantID = localStorage.getItem('tenantId');
        try {
            const mediaData = await http({
                url: `/api/media/list?tenantID=${tenantID}`,
                method: 'GET'
            });
            dispatch(getAllMedia(mediaData.data));
            return mediaData.data;
        } catch (e) {
            console.error('Service::GetAllMedia', e);
            throw e;
        }
    };
}

/**
 * Upload file
 * @param acceptedFile
 */
export function uploadFile(acceptedFile, type) {
    return async (dispatch: Dispatch<any>) => {
        const cssToken = Cookies.get('csst');
        if (cssToken) {
            try {
                const formData = new FormData();
                formData.append('file', acceptedFile);

                const response = await axios.post(
                    config.api.endpoints.upload,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${cssToken}`
                        },
                        withCredentials: true
                    }
                );
                const mediaType =
                    (response?.data?.mimetype &&
                        response?.data?.mimetype?.split('/')[0]) ||
                    type;
                if (response.data?.full) {
                    await dispatch(
                        saveMediaToLibrary({
                            label: getFilenameWithoutExtension(
                                response.data.filename
                            ),
                            src: response.data.full,
                            type: mediaType
                        })
                    );
                }
                // add dispatch to add to current queue; or use state from current file
                return {
                    path: response.data.full,
                    filename: response.data.filename,
                    mimetype: mediaType
                };
            } catch (e) {
                throw e;
            }
        }
    };
}

export function getMediaGallery() {
    return async (
        dispatch: Dispatch<any>,
        getState: () => IApplicationState
    ) => {
        try {
            const endpoint = '/api/media';

            const response = await http.get(endpoint);
            console.log(response);
            dispatch({
                type: actionType.GET_ALL_MEDIA,
                payload: response.data.medias
            });

            return response.data;
        } catch (e) {
            console.error('Service::GetAllMedia', e);
            throw e;
        }
    };
}

export function deleteMedia(id: number) {
    return async (
        dispatch: Dispatch<any>,
        getState: () => IApplicationState
    ) => {
        try {
            const endpoint = `/api/media/${id}`;

            const response = await http.delete(endpoint);
            dispatch({
                type: actionType.DELETE_MEDIA,
                payload: id
            });

            return response.data;
        } catch (e) {
            console.error('Failed to delete media ', e);
            throw e;
        }
    };
}
function saveMediaToLibrary(data) {
    return async (
        dispatch: Dispatch<any>,
        getState: () => IApplicationState
    ) => {
        try {
            const endpoint = '/api/media';
            const response = await http.post(endpoint, data);
            dispatch({
                type: actionType.ADD_NEW_MEDIA,
                payload: { ...response.data.media }
            });

            return response.data;
        } catch (e) {
            console.error('Failed to delete media ', e);
            throw e;
        }
    };
}

export function updateMedia(id, data) {
    return async (
        dispatch: Dispatch<any>,
        getState: () => IApplicationState
    ) => {
        try {
            const endpoint = `/api/media/${id}`;

            const response = await http.put(endpoint, data);
            dispatch({
                type: actionType.UPDATE_MEDIA,
                payload: { ...data }
            });

            return response.data;
        } catch (e) {
            console.error('Failed to update media ', e);
            throw e;
        }
    };
}

export function increaseFrequency(id) {
    return async (
        dispatch: Dispatch<any>,
        getState: () => IApplicationState
    ) => {
        try {
            const endpoint = `/api/media/${id}/frequency`;

            http.post(endpoint);
            dispatch({
                type: actionType.SORT_MEDIA,
                payload: { id }
            });

            return true;
        } catch (e) {
            console.error('Failed to update media ', e);
            throw e;
        }
    };
}
/**
 *
 * @param data
 */
export function saveMedia(data) {
    return async (dispatch: Dispatch<any>) => {
        // @todo: Get Tenant ID from store rather than localstorage
        const tenantID = localStorage.getItem('tenantId');
        data.tenantID = tenantID;
        try {
            const url = '/api/media/add';
            const response = await http.post(url, data);
            dispatch(addNewMedia(response.data));
            return response.data;
        } catch (e) {
            throw e;
        }
    };
}
